const CLIENT_ID = process.env.AUTH_CLIENT_APP_ID;
const AUTH_HOST = process.env.AUTH_HOST;
const REDIRECT_URI = '<APP_HOST>/auth'; // not used as is, will be replaced
const SIGN_OUT_ACTION = 'logout';
// const SIGN_IN_COGNITO_ACTION = 'login';
const SIGN_IN_ACTION = 'oauth2/authorize';

// https://auth.qa.pd.jobtarget.com/oauth2/authorize
// ?identity_provider=Azure
// &redirect_uri=https://distribution-admin.qa.pd.jobtarget.com/auth
// &response_type=CODE
// &client_id=3qot8kftdnce2ag5tt2cgo36b5
// &scope=email openid profile aws.cognito.signin.user.admin

const PARAMS = {
  identity_provider: 'Azure',
  response_type: 'CODE',
  scope: 'email openid profile aws.cognito.signin.user.admin', //phone+email+profile+openid+aws.cognito.signin.user.admin
  redirect_uri: REDIRECT_URI,
  client_id: CLIENT_ID,
};

export function getSignInOpts(opts = {}) {
  return {
    BASE_URL: `${AUTH_HOST}/${SIGN_IN_ACTION}`,
    PARAMS: { ...PARAMS, ...opts },
  };
}

export function getSignOutOpts(opts = {}) {
  return {
    BASE_URL: `${AUTH_HOST}/${SIGN_OUT_ACTION}`,
    PARAMS: { client_id: CLIENT_ID, logout_uri: REDIRECT_URI, ...opts },
  };
}

/**
 * @unsafe use our own getSignInOpts facade instead
 **/
// export function getSignInCognitoOpts(opts = {}) {
//   return {
//     BASE_URL: `${AUTH_HOST}/${SIGN_IN_COGNITO_ACTION}`,
//     PARAMS: { ...PARAMS, ...opts },
//   };
// }
